/* Geneva by Design — infinite scroll for collection / search product grids.
   Progressive enhancement: pagination links stay in the DOM (hidden) as a fallback. */
(function () {
  if (window.customElements.get('gv-infinite-scroll')) return;

  class GvInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.nextUrl = this.getAttribute('data-next') || '';
      this.list = document.getElementById(this.getAttribute('data-target') || '') || document.querySelector('product-list');
      if (!this.list || !this.nextUrl) return;

      this.loading = false;
      this.autoLoads = 0;
      this.maxAuto = 6; // after this many auto-loads, require a click (keeps very long lists sane)

      this.innerHTML =
        '<div class="gv-inf"><button type="button" class="gv-btn gv-btn--ghost gv-inf__btn" hidden>Load more</button>' +
        '<span class="gv-inf__status" role="status" aria-live="polite"></span></div>';
      this.btn = this.querySelector('.gv-inf__btn');
      this.status = this.querySelector('.gv-inf__status');
      this.btn.addEventListener('click', () => this.load(true));

      const nav = this.closest('.collection__main, .collection')?.querySelector('.pagination');
      if (nav) nav.setAttribute('hidden', '');

      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) this.load(false);
      }, { rootMargin: '600px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    finish() {
      this.observer?.disconnect();
      this.btn.hidden = true;
      this.status.textContent = '';
    }

    async load(manual) {
      if (this.loading || !this.nextUrl) return;
      if (!manual && this.autoLoads >= this.maxAuto) {
        this.btn.hidden = false;
        return;
      }
      this.loading = true;
      this.btn.hidden = true;
      this.status.textContent = 'Loading more products…';

      try {
        const res = await fetch(this.nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const nextList = doc.getElementById(this.list.id) || doc.querySelector('product-list');
        if (!nextList) throw new Error('no list');

        const frag = document.createDocumentFragment();
        Array.from(nextList.children).forEach((node) => {
          node.removeAttribute('reveal-on-scroll');
          frag.appendChild(node);
        });
        this.list.appendChild(frag);

        const marker = doc.querySelector('gv-infinite-scroll');
        this.nextUrl = marker ? marker.getAttribute('data-next') : '';
        if (!manual) this.autoLoads += 1;

        if (this.nextUrl) {
          this.status.textContent = '';
          if (this.autoLoads >= this.maxAuto) this.btn.hidden = false;
        } else {
          this.finish();
        }
      } catch (e) {
        this.status.textContent = '';
        this.btn.hidden = false;
        this.btn.textContent = 'Load more';
      } finally {
        this.loading = false;
      }
    }
  }

  window.customElements.define('gv-infinite-scroll', GvInfiniteScroll);
})();
